import { h } from 'preact'
import classnames from 'classnames'

export function SubmitButton ({ processing = false, onClick = () => {}, children, ...props }) {

	const classes = classnames(
		props['class'],
		props['className'],
		'button--icon-no-transition',
		processing && 'button--icon-left button--icon-nudge-up'
	)

	delete props['class']
	delete props['className']

	return <button class={classes} type="submit" disabled={processing} onClick={onClick} {...props}>
		{processing && <div class="button__icon spinner"></div>}
		{children} 
	</button>
}